export default "__VITE_ASSET__BqThVOSv__"